/**
 * 화면 표시용 단순 포매팅 함수.
 * (hook으로 만들기엔 비용 대비 가치가 낮은 1줄짜리 변환들)
 */

const GENDER_LABEL: Record<string, string> = {
  M: '남',
  F: '여',
  MALE: '남',
  FEMALE: '여',
  남성: '남',
  여성: '여',
};

/** "M" → "남" / "F" → "여" / 한글 그대로 / null → '' */
export const normalizeGenderLabel = (g: string | null | undefined): string => {
  if (!g) return '';
  return GENDER_LABEL[String(g).toUpperCase()] ?? GENDER_LABEL[String(g).trim()] ?? String(g);
};

/** 환자 이름 첫 글자 (아바타용) */
export const getPatientInitial = (name: string | null | undefined, fallback: string = '?'): string => {
  const n = (name ?? '').trim();
  if (!n) return fallback;
  return n.charAt(0);
};
